// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = false /* Default a true se non specificato*/ 
}) => {

    const { t } = useTranslation();

    const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner">

            <video autoPlay muted loop playsInline preload="metadata">
                <source src={`${LARGE_FILES_URL}/videoHero.mp4`} type="video/mp4" />
            </video>
            <div className="text-wrapper">
                <p className="sub-title">{t('homePage.hero.subTitle')}</p>
                <h1 className="title mb-4 mb-lg-5" dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }}></h1>
                <Link to="/immobili" className="btn">{t('homePage.hero.buttonText')}</Link>
            </div>

            { /* Attiva box a comparsa + form ricerca */}
            {false && (
                <div className="container-fluid">
                    <div className="text-wrapper">
                        <div className="row justify-content-center">
                            <div className="col-11">
                                {showSearchForm && <PropertySearchField searchData={{}} />}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Attiva l'indicatore di scroll */}
            {false && (
                <div className="scroll-indicator">
                    <span>scroll</span>
                    <div className="scroll-bar"></div>
                </div>
            )}
        </section>
    );
};

export default SubHeaderHome;